// extracted by mini-css-extract-plugin
export default {"tab":"ZnNJ8","banner":"d7ucl"};